import React from "react";

const formatDuration = (minutes) => {
    const hrs = Math.floor(minutes / 60);
    const mins = Math.round(minutes % 60);
    return `${hrs}h ${mins}m`;
};

const RouteItineraryReportTable = ({legs, stops}) => (

    <div>

        <h5>Route Itinerary Report</h5>
        
        <table className="milemaker-report-table">        
        
            <thead>
            	<tr>
                	<th>Maneuver</th>
                	<th>Maneuver Distance (mi)</th>
                	<th>Total Distance (mi)</th>
                	<th>Maneuver Duration</th>
                	<th>Total Duration</th>
            	</tr>
            </thead>

            <tbody>
            
            {legs.map((step, i) => (
                <React.Fragment key={i}>

                    <tr className="stop-row">
                        <td colSpan="5" className="align-left">

                            <strong>STOP {i + 1}:</strong> &nbsp; 
                            {stops?.[i]?.displayName || "Unknown Location"}
                            <br/>
							<small>
          						{stops?.[i]?.address?.county ? `County: ${stops[i].address.county}, ` : ""}
                                {stops?.[i]?.address?.stateCode ? `State: ${stops[i].address.stateCode}` : ""}
                                {stops?.[i]?.splc ? ` | SPLC: ${stops[i].splc}` : ""}
        					</small>

                        </td>
                    </tr>
                    {step.itinerary.map((itinerary, j) => (
                        <tr key={`${i}-${j}`} style={{borderBottom: "1px solid #e9ecef"}}>
                            <td className="align-left">{itinerary.maneuver}</td>
                            <td>{itinerary.length?.value?.toFixed(2)}</td>
                            <td>{itinerary.totalLength?.value?.toFixed(2)}</td>
                            <td>{formatDuration(itinerary.duration?.value)}</td>
                            <td>{formatDuration(itinerary.totalDuration?.value)}</td>
                        </tr>
                    ))}
                </React.Fragment>
            ))}

            <tr className="final-stop-row">
                <td colSpan="5" className="align-left">

                    <strong>Final Stop:</strong> &nbsp;
					{stops?.[stops.length - 1]?.displayName || "Unknown Location"}
                    <br />
                    <small>
          				{stops?.[stops.length - 1]?.address?.county ? `County: ${stops[stops.length - 1].address.county}, ` : ""}
                        {stops?.[stops.length - 1]?.address?.stateCode ? `State: ${stops[stops.length - 1].address.stateCode}` : ""}
                        {stops?.[stops.length - 1]?.splc ? ` | SPLC: ${stops[stops.length - 1].splc}` : ""}
        			</small>

                </td>
            </tr>

            </tbody>
        </table>
    </div>
);

export default RouteItineraryReportTable;